import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Column from '@amzn/meridian/column'
import Input from '@amzn/meridian/input'
import Button from '@amzn/meridian/button'
import { StoreIdServiceFor3P } from '@src/pages/StoreIdSelectionFor3P/utils/StoreIdServiceFor3P'
import Text from '@amzn/meridian/text'

const STORE_ID_REGEX = new RegExp('^[0-9a-zA-Z\\\\-]{1,32}$')
const StoreIdInputPage = () => {
    const navigate = useNavigate()
    const [errorValue, setErrorValue] = useState(true)
    const [inputValue, setInputValue] = useState('')
    const [errorMsg, setErrorMsg] = useState(null)
    const setStoreId = async (storeId: string) => {
        console.log('ATBase: Setting storeId', storeId)
        try {
            setErrorValue(true)
            setErrorMsg(null)
            await StoreIdServiceFor3P.setSelectedStoreIdAndStoreDetail(storeId, true)
            navigate('/provision')
        } catch (error) {
            setErrorValue(false)
            navigate('/input-store-id')
            setErrorMsg(error.message)
            console.error('ATBase: Exception occurred while setting selected store', error)
        }
    }

    return (
        <>
            <Column spacing={'large'} spacingInset={'xlarge'} alignmentVertical={'center'} height={'100%'} width={'100%'}>
                <Input pattern={ STORE_ID_REGEX } value={inputValue} onChange={setInputValue} size={'xlarge'} type={'text'} placeholder={'Enter Store ID'}/>
                <Button size ={'large'} type={'primary'} onClick={() => { setStoreId(inputValue) }} > Proceed {`>>`} </Button>
                { !errorValue && <Text type="h200" alignment="center" >
                    { errorMsg }
                </Text> }
            </Column>
        </>
    )
}

export default StoreIdInputPage
